import React from 'react'

function RecipesShowcase() {
  const recipes = [
    { name: 'Pão Francês', img: 'https://static.lumi.new/63/63b87d79959077004245eaeaf8adf198.png' },
    { name: 'Pão Australiano', img: 'https://static.lumi.new/a5/a52f71399b55163e843b29be61772917.png' },
    { name: 'Brioche', img: 'https://static.lumi.new/21/21056564d328ca302093cc5281607289.png' },
    { name: 'Pão de Hambúrguer', img: 'https://static.lumi.new/c9/c9c315a3d42baec3d11f64ad92f2bf81.png' },
    { name: 'Focaccia', img: 'https://static.lumi.new/75/75bda545d8b10c30a993ab6e0d9f8468.png' },
    { name: 'Croissant', img: 'https://static.lumi.new/4c/4c4e482686b0d96b84c5133285052420.png' },
    { name: 'Pizza', img: 'https://static.lumi.new/0c/0c7270afcfc56a356db5c50d977e52a8.png' },
    { name: 'Rosca Doce', img: 'https://static.lumi.new/04/04b97725b4a1988d6242e24bc4bfd927.png' },
    { name: 'Cinnamon Roll', img: 'https://static.lumi.new/04/04b97725b4a1988d6242e24bc4bfd927.png' },
  ]

  return (
    <section className="bg-white py-20 md:py-28">
      <div className="max-w-[1200px] mx-auto px-6 md:px-10">
        <div className="text-center mb-14 animate-fade-up">
          <h2 className="font-display text-[#49352B] text-3xl md:text-5xl font-bold">
            Você vai aprender receitas como:
          </h2>
        </div>

        <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-6">
          {recipes.map((r, i) => (
            <div
              key={i}
              className="flex items-center gap-4 bg-[#FCFAF5] rounded-[20px] border border-[#EBD9C3] p-3 shadow-sm hover:shadow-lg transition-all duration-300 hover:-translate-y-1 animate-fade-up"
            >
              <img src={r.img} alt={r.name} className="w-20 h-20 rounded-[14px] object-cover flex-shrink-0" />
              <span className="text-[#49352B] font-semibold flex items-center gap-2">
                <span className="text-[#5E774B]">✔</span> {r.name}
              </span>
            </div>
          ))}
          <div className="flex items-center justify-center bg-[#EBD9C3]/50 rounded-[20px] border border-[#D9891B]/30 p-3 shadow-sm animate-fade-up">
            <span className="text-[#49352B] font-display font-bold text-lg">✔ Muito mais...</span>
          </div>
        </div>
      </div>
    </section>
  )
}

export default RecipesShowcase
